import { useSelector } from 'react-redux';
import { RootStateType } from '../../../../redux/store';
import { fymAPI } from '../../../../redux/api/fymAPI';

/**
 * True while a look PATCH is on its way. The server copies the kit look into an asset when it
 * makes the asset, so "Make it" waits for the look change to land first. The look panel queues
 * its PATCHes back to back, so the store holds a pending one until the last ends. The mutation
 * state keeps no arguments, and the Studio shows the look of one song only, so any look PATCH counts.
 */
export function useIsKitLookSaving(): boolean {
  return useSelector((state: RootStateType) =>
    Object.values(state[fymAPI.reducerPath].mutations).some(
      (mutation) => mutation?.endpointName === 'updateKitLook' && mutation.status === 'pending'
    )
  );
}
